import { useContext } from 'react'
import { SearchContext } from './search-context'
import {
  SearchContainerDesktop,
  SearchContainerGlobal,
  SearchContainerMobile
} from '../styled-components'
import { searchVariantsOptions } from '../constants'

const SearchVariants = {
  [searchVariantsOptions.DESKTOP]: SearchContainerDesktop,
  [searchVariantsOptions.MOBILE]: SearchContainerMobile,
  [searchVariantsOptions.GLOBAL]: SearchContainerGlobal
}

const SearchContainer = ({ children }) => {
  const { variant, isOpenInput, containerRef, buttonSize } =
    useContext(SearchContext)

  const SearchContainerComponent =
    SearchVariants[variant] ?? SearchContainerDesktop

  return (
    <SearchContainerComponent
      style={{
        width: `calc(100% - ${buttonSize}px)`
      }}
      data-is-open={isOpenInput}
      ref={containerRef}
    >
      {children}
    </SearchContainerComponent>
  )
}

export default SearchContainer
